import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import * as Icons from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a secure reset link">
      {sent ? (
        <div className="text-center py-6">
          <div className="h-12 w-12 rounded-full bg-primary/15 text-primary grid place-items-center mx-auto mb-4">
            <Icons.MailCheck className="h-6 w-6" />
          </div>
          <p className="text-sm text-muted-foreground">
            If that email is registered, a reset link has been sent. Check your inbox.
          </p>
          <Link to="/login" className="inline-block mt-6 text-primary font-medium hover:underline" data-testid="back-to-signin">
            Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-1.5" data-testid="forgot-email-input" placeholder="you@company.co.uk" />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit-button">
            {busy ? <Icons.LoaderCircle className="h-4 w-4 animate-spin" /> : "Send reset link"}
          </Button>
          <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Back to sign in</Link>
        </form>
      )}
    </AuthShell>
  );
}
